/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Contract_Created_BodyInputs */



/**
* | output |
* | --- |
* | "Nobody can sign in yet. Once oneAI approves the contract, the organization wakes on its start date — or straight away if it starts today — the prepaid budget..." |
*
* @param {Partner_Add_Contract_Created_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_contract_created_body = /** @type {((inputs?: Partner_Add_Contract_Created_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Contract_Created_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es kann sich noch niemand anmelden. Sobald oneAI den Vertrag freigibt, wird die Organisation am Starttermin aktiviert — oder sofort, wenn sie heute beginnt —, das vorausbezahlte Budget wird gutgeschrieben und die Administration erhält eine Einladung per E-Mail. Ab dann können Sie sie über die Kundenseite erneut senden, bis die Registrierung abgeschlossen ist.")
	return /** @type {LocalizedString} */ ("Nobody can sign in yet. Once oneAI approves the contract, the organization wakes on its start date — or straight away if it starts today — the prepaid budget is added, and the administrator is emailed an invitation. From then on you can resend it from the customer's page until they sign up.")
});